export const USER = 'USER'
export const UNIT_TYPE='UNIT_TYPE'
export const DEALER_DETAILS_UPDATE='DEALER_DETAILS_UPDATE'